import { signalStore, withHooks, withState } from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { Tag } from '../../models/tag';
import { withTagSelectors } from './tag.selectors';
import { TagService } from '../../services/tag/tag.service';
import { withLogging } from '../features/logger.feature';

export type TagState = BaseState<Tag>;

export const initialState: TagState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'Tag',
  entityLabel: 'Schlagwort',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const TagStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Tag>(TagService),
  withLogging(initialState.entityType),
  withTagSelectors(),
  withHooks({
    onInit({ loadAllItemsByPromise }) {
      loadAllItemsByPromise();
    },
  })
);
